<template>
    <label class="mb-0">
        <input type="checkbox" 
            class="mr-2" 
            v-on:click="applyFilter" 
            :checked="isChecked" /> {{ displayFilterValue }} <span class="badge badge-primary ml-2"> {{ filterData.doc_count }} </span>
    </label>
</template>

<script>
    export default {
        props: {
            referrerUrl: { type: String, required: true },
            filterFieldName: { type: String, required: true },
            filterData: { type: Object, required: true },
            filterQueryParameterName: { type: String, required: false, default: 'filters' },
            isChecked: { type: Boolean, required: true, default: false },
            translateValues: { type: Boolean, required: false, default: false }
        },

        methods: {
            applyFilter() {
                window.location = this.filterUrl;
            }
        },

        computed: {
            displayFilterValue() {
                let displayValue = '[not specified]';
                if (this.filterData.key !== '') {
                    displayValue = this.translateValues ? this.translate('frontend.search.filters.' + this.filterData.key) : this.filterData.key;
                }
                return displayValue;
            },

            filterUrl() {
                // reset the page number in the referrer url
                let referrerUrlWithPageReset = this.referrerUrl.replace(/page=()\d+/g, 'page=1');

                if (this.isChecked) {
                    // remove the selected filter parameter from the referrer url
                    let regex = new RegExp('&?' + this.filterQueryParameterName + '\\[' + this.filterFieldName + '\\]\\[\\]=' + this.filterData.key);
                    return encodeURI(referrerUrlWithPageReset.replace(regex, ''));
                } else {
                    // append the selected filter parameter to the referrer url
                    return encodeURI(referrerUrlWithPageReset + '&filters' + '[' + this.filterFieldName + '][]=' + this.filterData.key);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    label {
        font-size: 1rem;
        vertical-align: middle;
        cursor: pointer;
    }

    input[type="checkbox"] {
        vertical-align:middle;
    }

    .badge {
        vertical-align: top;
        border-radius: 100px;
        color: darken( #879ca2, 30%);
        background-color: lighten(#879ca2, 30%);
        padding: 4px 8px;
        min-height: 18px;
        min-width: 18px;
        vertical-align: baseline;
    }

</style>